import { RootState } from '../../../store';
import { selectIsFeatureFlagExplicitlyEnabled } from '../../../modules/featureFlags/featureFlagSelectors';
import { FeatureFlagKeys } from '../../../modules/featureFlags/featureFlagTypes';

/**
 * Whether the Swiftaid connection panel may be offered to the current session,
 * before the organisation's country is considered.
 *
 * `SwiftaidConnect` releases the panel to everyone. `SwiftaidConnectSysAdmin`
 * lets system admins test the link ahead of that release; feature flags are
 * evaluated without a user context, so the role check has to happen here.
 * Both are explicit opt-in, so an absent flag keeps the panel hidden.
 */
export const selectIsSwiftaidConnectEnabled = (state: RootState): boolean =>
  selectIsFeatureFlagExplicitlyEnabled(
    state,
    FeatureFlagKeys.SwiftaidConnect
  ) ||
  (!!state.session?.isSystemAdmin &&
    selectIsFeatureFlagExplicitlyEnabled(
      state,
      FeatureFlagKeys.SwiftaidConnectSysAdmin
    ));
